<div bsModal
     #staticModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">X</span>
        </button>
        <storever-header-modal [title]="'SITE_OFF_TITLE'" [icon]="'fal fa-times-circle'"></storever-header-modal>
      </div>
      <div class="modal-body">
        <div class="portlet-body" style="text-align:center;">
          {{'CONFIRM_SITE_OFF_TITLE' | translate:locale.language}}
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="send()">{{'GENERIC_OK' | translate:locale.language}} </button>
        <button type="button" class="btn btn-default" (click)="close()">{{'CANCEL' | translate:locale.language}}</button>
      </div>
    </div>
  </div>
</div>
